import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import PermissionSet from '../../interfaces/permissionSet';

interface PermissionSetState {
    permissionSet: PermissionSet[],
}

const initialState: PermissionSetState = {
    permissionSet: []
}

export const permissionSetSlice = createSlice({
    name: 'permissionSet',
    initialState,
    reducers: {
        loadPermissionSet: (state, action: PayloadAction<PermissionSet[]>) => {
            state.permissionSet = action.payload
        }
    }
});

export const { loadPermissionSet } = permissionSetSlice.actions;

export default permissionSetSlice.reducer;